<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div style="max-width: 20%!important;" class="col-xl-3 col-md-3">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-single-copy-04 text-info"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total Tickets</p>
              <h4 class="card-title">{{ tickets }}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-calendar-o"></i>Hoy
            </div>
          </stats-card>
        </div>

        <div style="max-width: 20%!important;" class="col-xl-3 col-md-3">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-cloud-upload-94 text-info"></i>
            </div>
            <div slot="content">
              <p class="card-category">Creada</p>
              <h4 class="card-title">{{ ticketsCreada }}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-calendar-o"></i>Hoy
            </div>
          </stats-card>
        </div>

        <div style="max-width: 20%!important;" class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-delivery-fast text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-category">En Ejecución</p>
              <h4 class="card-title">{{ ticketsEjecucion }}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-calendar-o"></i>Hoy
            </div>
          </stats-card>
        </div>

        <div style="max-width: 20%!important;" class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-check-2 text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Finalizada</p>
              <h4 class="card-title">{{ ticketsFinalizada }}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-calendar-o"></i>Hoy
            </div>
          </stats-card>
        </div>

        <div style="max-width: 20%!important;" class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-simple-remove text-danger"></i>
            </div>
            <div slot="content">
              <p class="card-category">Cancelada</p>
              <h4 class="card-title">{{ ticketsCancelada }}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-calendar-o"></i>Hoy
            </div>
          </stats-card>
        </div>

      </div>
      <div class="row">
        <div class="col-md-12">
          <chart-card :chart-data="lineChart.data" :chart-options="lineChart.options"
            :responsive-options="lineChart.responsiveOptions" ref="hijo">
            <template slot="header">
              <h4 class="card-title">Estadística</h4>
              <p class="card-category">Tickets en el Mes</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Creada
                <i class="fa fa-circle text-warning"></i> En Ejecucion
                <i class="fa fa-circle text-success"></i> Finalizada
                <i class="fa fa-circle text-danger"></i> Cancelada
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-calendar-o"></i>Ultimo Mes
              </div>
            </template>
          </chart-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ChartCard from 'src/components/Cards/ChartCard.vue'
import StatsCard from 'src/components/Cards/StatsCard.vue'
import LTable from 'src/components/Table.vue'
import getSecret from '../helpers/get-secret';
const serverUrl = getSecret('SERVER_URL');

export default {
  components: {
    LTable,
    ChartCard,
    StatsCard
  },
  data() {
    return {
      id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
      tickets: 0,
      ticketsCreada: 0,
      ticketsEjecucion: 0,
      ticketsFinalizada: 0,
      ticketsCancelada: 0,
      lineChart: {
        data: {
          labels: [],
          series: []
        },
        options: {
          low: 0,
          high: 1,
          showArea: false,
          height: '245px',
          axisX: {
            showGrid: false
          },
          lineSmooth: true,
          showLine: true,
          showPoint: true,
          fullWidth: true,
          chartPadding: {
            right: 50
          }
        },
        responsiveOptions: [
          ['screen and (max-width: 640px)', {
            axisX: {
              labelInterpolationFnc(value) {
                return value[0]
              }
            }
          }]
        ]
      },
    }
  },
  methods: {
    getParameters() {
      this.axios.get(serverUrl + '/api/getParameters/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            res.data.tickets.forEach((d) => {
              this.tickets += 1;
              if (d.status == 1) this.ticketsCreada += 1;
              if (d.status == 2) this.ticketsEjecucion += 1;
              if (d.status == 3) this.ticketsFinalizada += 1;
              if (d.status == 4) this.ticketsCancelada += 1;
            })
          } else {
            console.log('Error getParameters');
          }
        })
        .catch(err => {
          console.log('Error getParameters');
        });
    },
    getTicketsByMonth(year, month, days) {
      this.lineChart.data.series = [];
      this.daysTicketsCreate = [];
      this.daysTicketsEjecucion = [];
      this.daysTicketsFinish = [];
      this.daysTicketsCancelate = [];
      this.axios.get(serverUrl + '/api/getTicketsByMonth/' + year + '/' + month + '/' + days + '/' + this.id_company)
        .then(res => {
          res.data.tickets.forEach((d) => {
            d.day = new Date(d.date).getDate();
            if (d.status == 1) this.daysTicketsCreate.push(d.day);
            if (d.status == 2) this.daysTicketsEjecucion.push(d.day);
            if (d.status == 3) this.daysTicketsFinish.push(d.day);
            if (d.status == 4) this.daysTicketsCancelate.push(d.day);
          })
          const countsCreate = [];
          const countsEjecucion = [];
          const countsFinish = [];
          const countsCancelate = [];
          for (let i = 0; i < this.lineChart.data.labels.length; i++) {
            if (this.daysTicketsCreate.includes(this.lineChart.data.labels[i])) {
              let contador = 0;
              for (let j = 0; j < this.daysTicketsCreate.length; j++) {
                if (this.daysTicketsCreate[j] === this.lineChart.data.labels[i]) {
                  contador += 1;
                }
              }
              countsCreate.push(contador);
            } else {
              countsCreate.push(0);
            }
            if (this.daysTicketsEjecucion.includes(this.lineChart.data.labels[i])) {
              let contador1 = 0;
              for (let j = 0; j < this.daysTicketsEjecucion.length; j++) {
                if (this.daysTicketsEjecucion[j] === this.lineChart.data.labels[i]) {
                  contador1 += 1;
                }
              }
              countsEjecucion.push(contador1);
            } else {
              countsEjecucion.push(0);
            }
            if (this.daysTicketsFinish.includes(this.lineChart.data.labels[i])) {
              let contador2 = 0;
              for (let j = 0; j < this.daysTicketsFinish.length; j++) {
                if (this.daysTicketsFinish[j] === this.lineChart.data.labels[i]) {
                  contador2 += 1;
                }
              }
              countsFinish.push(contador2);
            } else {
              countsFinish.push(0);
            }
            if (this.daysTicketsCancelate.includes(this.lineChart.data.labels[i])) {
              let contador3 = 0;
              for (let j = 0; j < this.daysTicketsCancelate.length; j++) {
                if (this.daysTicketsCancelate[j] === this.lineChart.data.labels[i]) {
                  contador3 += 1;
                }
              }
              countsCancelate.push(contador3);
            } else {
              countsCancelate.push(0);
            }
          }
          this.lineChart.data.series.push(countsCreate);
          this.lineChart.data.series.push(countsCancelate);

          this.lineChart.data.series.push(countsEjecucion);
          this.lineChart.data.series.push([0]);
          this.lineChart.data.series.push(countsFinish);
          let mayor = 0;
          for (let i = 0; i < this.lineChart.data.series.length; i++) {
            const subarray = this.lineChart.data.series[i];
            for (let j = 0; j < subarray.length; j++) {
              if (subarray[j] > mayor) {
                mayor = subarray[j];
              }
            }
          }
          this.lineChart.options.high = mayor + 1;
          const hijo = this.$refs.hijo;
          console.log(this.lineChart.data.series)
          console.log(this.lineChart.data.labels)
          hijo.initChart();
        })
        .catch(err => {
          console.log(err);
          console.log('Error getTicketsByMonth');
        });
    },
  },
  created() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const numberDays = new Date(year, month, 0).getDate();
    for (let i = 1; i <= numberDays; i++) {
      this.lineChart.data.labels.push(i);
    }
    this.getTicketsByMonth(year, month, numberDays);
  },
  mounted() {
    this.getParameters();
  }
}
</script>
<style></style>
